import styles from "./index.module.css";
import Input from "../../../Components/FormComponents/Input";
import FakeButton from "../../../Components/FormComponents/FakeButton";
import { use, useEffect, useState } from "react";
import InputPhone from "../../../Components/FormComponents/PhoneInput";
import UserContext from "../../../store/UserStore/context";
import RadioButton from "../../../Components/FormComponents/RadioButton";
import Texture from "../../MainPage/PriceBlock/texture2.jpg";
import Fetch from "../../helpers/fetch";
import { apiUrl } from "../../../config";

export default function Form({ key }) {
  const [name, setName] = useState("");
  const [phoneNumber, setPhone] = useState("");
  const [tgUsername, setTgUsername] = useState("");
  const [liqpayData, setliqpayData] = useState(null);
  const [time, setTime] = useState(20);
  const [request, setRequest] = useState(false);
  const [monopaydata, setMonopayData] = useState(null);
  const userStore = use(UserContext);
  useEffect(() => {
    if (liqpayData) {
      const form = document.getElementById("liqpay-form");
      form.submit();
    }
  }, [liqpayData, setliqpayData]);

  async function submitMono(isHalfPrice = false) {
    if (request) return;
    setRequest(true);
    const res = await Fetch.post(apiUrl("/api/intensive/payment/mono"), {
      email: userStore.store.user.email,
      phoneNumber: `+${phoneNumber}`,
      tgUsername,
      name,
      isHalfPrice,
      time,
    });
    if (res.ok) {
      const monopaydata = await res.json();
      setMonopayData(monopaydata);
      window.location = monopaydata.link;
    }
    setRequest(false);
  }

  async function submitLiqpay(isHalfPrice = false) {
    const postres = await fetch(apiUrl("/api/intensive/payment"), {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "post",
      body: JSON.stringify({
        email: userStore.store.user.email,
        phoneNumber: `+${phoneNumber}`,
        tgUsername,
        name,
        isHalfPrice,
        time,
      }),
    });
    if (postres.ok) {
      setliqpayData(await postres.json());
    }
  }
  return (
    <div id={"target"}>
      <div
        className={styles.content}
        style={{ backgroundImage: `url(${Texture})` }}
      >
        <h2>Запис на інтенсив</h2>
        <div className={styles.contentBlocks}>
          <Input
            value={name}
            onChange={setName}
            className={styles.field}
            placeholder={"Ім'я"}
            label={"Ім'я"}
          />
          <InputPhone
            value={phoneNumber}
            onChange={setPhone}
            className={styles.field}
            placeholder={"00 000 00 00"}
            label={"Номер телефону"}
          />
          <Input
            value={tgUsername}
            onChange={setTgUsername}
            className={styles.field}
            placeholder={"@ytg"}
            label={"Профіль Telegram"}
          />
          <div>
            <div className={styles.time}>Час</div>
            <div className={styles.checkboxContainer}>
              {key !== "B2C1" || key !== "A2B1" ? (
                <RadioButton
                  option={"10:00"}
                  checked={time === 10}
                  onChange={(e) => {
                    setTime(10);
                  }}
                />
              ) : null}

              <RadioButton
                option={"20:00"}
                onChange={(e) => setTime(20)}
                checked={time === 20}
              />
            </div>
          </div>

          <FakeButton
            red
            onClick={() => submitMono()}
            className={styles.button}
          >
            Оплатити повністю
          </FakeButton>
          <FakeButton
            briege
            onClick={() => submitMono(true)}
            className={styles.part}
          >
            Оплатити частинами
          </FakeButton>
          <div className={styles.message}>
            При оплаті не з українського банку іноді може відбуватись
            автоматичне повернення коштів. Якщо таке сталося — напишіть нам на
            електронну пошту{" "}
            <a href={"mailto:info@profound-english.community"} rel="noreferrer">
              info@profound-english.community
            </a>
            , і ми надамо вам деталі для оплати.
          </div>
          <div className={styles.privacy}>
            Натискаючи «Продовжити», ти приймаєш{" "}
            <a href={"/contract-offer"} target={"_blank"} rel="noreferrer">
              угоду
            </a>
          </div>
        </div>
      </div>

      <form
        id="liqpay-form"
        action="https://www.liqpay.ua/api/3/checkout"
        method="POST"
        acceptCharset="utf-8"
        style={{ display: "none" }} // Сховати форму, щоб не відображати її на екрані
      >
        <input type="hidden" name="data" value={liqpayData?.data} />
        <input type="hidden" name="signature" value={liqpayData?.signature} />
      </form>
    </div>
  );
}
